export const tagSystemPath = 'tag-system';
